import { useState, useMemo } from "react";
import { CategoryBar } from "./CategoryBar.jsx";
import { PlaceCard } from "./PlaceCard.jsx";
import { filterByCategory } from "../lib/categories.js";
import { scoreTown } from "../lib/scoring.js";
import { USERS } from "../lib/user.js";

// Airbnb-stijl landingspagina: zoekbalk + categorie-filters + raster
// van plaats-kaarten, gesorteerd op score. Kaart is een toggle.
export function HomeGrid({ towns, concelhoBySlug, weights, favorites, onToggleFav, onOpenTown, onShowMap, onOpenCriteria, onOpenSearch, onOpenCompare, canEdit = true, user, onSwitchUser, compareSel, onToggleCompare, enforceVeto = false, waterVeto = false }) {
  const [category, setCategory] = useState("all");
  const [favOnly, setFavOnly]   = useState(false);

  const visible = useMemo(() => {
    let list = filterByCategory(towns, concelhoBySlug, category);
    if (favOnly) list = list.filter(t => favorites.has(t.name));
    const sc = t => scoreTown(t, weights, concelhoBySlug[t.concelho], enforceVeto, { waterVeto });
    return [...list].sort((a, b) => {
      const sa = sc(a), sb = sc(b);
      // Uitgesloten (gefaalde harde eis) altijd onderaan, daarna op score.
      if (!!sa.excluded !== !!sb.excluded) return sa.excluded ? 1 : -1;
      return sb.pct - sa.pct;
    });
  }, [towns, concelhoBySlug, weights, category, favOnly, favorites, enforceVeto, waterVeto]);

  return (
    <div className="home-grid">
      <div className="home-topbar">
        <span className="home-brand">⛰ Portugal Verkenner</span>
        <button className="home-search" onClick={onOpenSearch || onOpenCriteria}>
          <span className="home-search-ico">🔍</span>
          <span className="home-search-txt">
            <span className="home-search-main">Zoek een plek</span>
            <span className="home-search-sub">Regio · klimaat · prioriteiten</span>
          </span>
        </button>
        <div className="home-actions">
          {user && (
            <button className="home-pill" onClick={onSwitchUser} title="Wissel gebruiker">
              {USERS[user]?.emoji} {USERS[user]?.name}{!canEdit ? " (kijk)" : ""}
            </button>
          )}
          <button className="home-pill home-pill-map" onClick={onShowMap}>🗺 Kaart</button>
          <button className={`home-pill${favOnly ? " home-pill-on" : ""}`} onClick={() => setFavOnly(v => !v)}>★ Bewaard</button>
          {compareSel && compareSel.size >= 2 && (
            <button className="home-pill home-pill-on" onClick={onOpenCompare}>⚖ Vergelijk ({compareSel.size})</button>
          )}
          <button className="home-pill" onClick={onOpenCriteria}>⚙ Criteria</button>
        </div>
      </div>

      <CategoryBar active={category} onChange={setCategory} />

      {visible.length === 0 ? (
        <p className="home-empty">Geen plaatsen in deze categorie{favOnly ? " (en bewaard)" : ""}.</p>
      ) : (
        <div className="home-cards">
          {visible.map(t => (
            <PlaceCard
              key={t.name}
              town={t}
              concelho={concelhoBySlug[t.concelho]}
              weights={weights}
              isFav={favorites.has(t.name)}
              onToggleFav={onToggleFav}
              canEdit={canEdit}
              inCompare={compareSel ? compareSel.has(t.name) : false}
              onToggleCompare={onToggleCompare}
              enforceVeto={enforceVeto}
              waterVeto={waterVeto}
              onOpen={onOpenTown}
            />
          ))}
        </div>
      )}

      <div className="home-mapbtn-wrap">
        <button className="home-mapbtn" onClick={onShowMap}>🗺 Toon kaart</button>
      </div>
    </div>
  );
}
